import logo from "@/assets/artbaz-logo.png.asset.json";
import logoMark from "@/assets/artbaz-logo-2.png.asset.json";

import hero from "@/assets/artbaz-hero.png.asset.json";
import oNasRekonstrukcia from "@/assets/o-nas-rekonstrukcia.png.asset.json";
import oNasStavba from "@/assets/o-nas-stavba.png.asset.json";
import oNasKuchyne from "@/assets/o-nas-rekonstrukcia-kuchyne.png.asset.json";
import oNasSluzby from "@/assets/o-nas-stavebne-sluzby.png.asset.json";
import orly2021 from "@/assets/orly-2021.png.asset.json";
import orly2023 from "@/assets/orly-2023.png.asset.json";

export const assets = {
  logo: logo.url,
  logoMark: logoMark.url,
  hero: hero.url,
  oNasRekonstrukcia: oNasRekonstrukcia.url,
  oNasStavba: oNasStavba.url,
  oNasKuchyne: oNasKuchyne.url,
  oNasSluzby: oNasSluzby.url,
  orly2021: orly2021.url,
  orly2023: orly2023.url,
};

export const navLinks = [
  { label: "Domov", href: "/" },
  { label: "Služby", href: "/#sluzby" },
  { label: "Realizácie", href: "/realizacia" },
  { label: "O nás", href: "/#o-nas" },
  { label: "Kontakt", href: "/kontakt" },
];

export const stats = [
  { value: 300, suffix: "+", label: "Dokončených projektov" },
  { value: 8, suffix: "+", label: "Rokov skúseností" },
  { value: 100, suffix: "%", label: "Komplexné riešenia" },
];

export const services = [
  {
    title: "Rekonštrukcie a stavby",
    description:
      "Kompletné rekonštrukcie bytov, domov, komerčných a priemyselných objektov. Stavby na kľúč od projektu až po odovzdanie.",
    icon: "Building2",
  },
  {
    title: "Návrhy a poradenstvo",
    description:
      "Konzultácie, návrhy interiérov, vizualizácie, výber materiálov, odborné posúdenie nehnuteľností a odhad nákladov na rekonštrukciu.",
    icon: "PencilRuler",
  },
  {
    title: "Kúpeľne a interiéry",
    description:
      "Rekonštrukcie kúpeľní na kľúč, obklady, dlažby, veľkoformátové formáty, kuchyne na mieru, vstavaný nábytok a interiérové riešenia.",
    icon: "Bath",
  },
  {
    title: "Technické inštalácie",
    description:
      "Rozvody vody, odpadu, elektriny a kúrenia. Podlahové vykurovanie, elektrické vykurovacie systémy a montáž klimatizácií.",
    icon: "Wrench",
  },
  {
    title: "Stavebné a dokončovacie práce",
    description:
      "Murárske práce, omietky, sadrokartóny, zatepľovanie, podlahy, okná, dvere, maľovanie a dekoratívne povrchové úpravy.",
    icon: "Hammer",
  },
  {
    title: "Exteriéry a drevené konštrukcie",
    description:
      "Strechy, oplotenia, zámkové dlažby, prístrešky, schodiská, drevené prvky, terénne úpravy, údržba zelene a realizácia okolia stavieb.",
    icon: "Trees",
  },
] as const;

export const testimonials = [
  {
    name: "Martina K.",
    role: "Rekonštrukcia bytu, Trenčín",
    rating: 5,
    text: "Profesionálny prístup od prvej konzultácie až po odovzdanie. Byt je ako nový, všetko dokončené načas a presne podľa dohody. Vrelo odporúčam.",
  },
  {
    name: "Peter H.",
    role: "Stavba rodinného domu",
    rating: 5,
    text: "Stavbu domu sme zverili ARTBAZ-u a bola to správna voľba. Komunikácia bez problémov, kvalita práce na vysokej úrovni a férové ceny.",
  },
  {
    name: "Jana S.",
    role: "Rekonštrukcia kúpeľne",
    rating: 5,
    text: "Kúpeľňa predčila naše očakávania. Skvelý výber materiálov, precízne obklady a čistá práca. Ďakujeme za trpezlivosť a poradenstvo.",
  },
  {
    name: "Tomáš V.",
    role: "Kuchyňa na mieru",
    rating: 5,
    text: "Kuchyňa na mieru je nádherná a praktická. Oceňujem najmä detailné spracovanie a to, že dodržali každý termín. Top tím.",
  },
  {
    name: "Lucia M.",
    role: "Kompletná rekonštrukcia",
    rating: 5,
    text: "Od návrhu po realizáciu všetko zvládli pod jednou strechou. Nemuseli sme nič riešiť, len sa tešiť z výsledku. Skvelá skúsenosť.",
  },
  {
    name: "Marek D.",
    role: "Zateplenie a fasáda",
    rating: 4,
    text: "Kvalitne odvedená práca, dom vyzerá výborne a ušetrili sme na energiách. Spoľahliví ľudia, na ktorých sa dá spoľahnúť.",
  },
];

export const contact = {
  email: "artbaz@artbaz.online",
  phone: "+421 918 974 121",
  phoneHref: "+421918974121",
  address: ["Pod Juhom 7666", "911 01 Trenčín"],
  instagram: "https://www.instagram.com/artbaz.stavebnafirma/",
};
